import React, { useEffect, useState } from 'react';
import emailjs from "emailjs-com"; 
import Swal from "sweetalert2";
import axios from 'axios';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        contact: '',
        address: '',
        source: '',
        income: '',
        query: '',
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
      wakeUpAPI();
    }, []);
  
    const wakeUpAPI = async () => {
      try {
        const response = await axios.get('https://sfa-blog.onrender.com/api/blogs?page=1&limit=1');
        // console.log('API woke up:', response.status);
      } catch (error) {
        // console.error('Error waking up API:', error.message);
      }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };

            // Re-validate each field on change
            switch (name) {
                case 'name':
                    if (!value.trim()) newErrors.name = 'Name is required';
                    else delete newErrors.name;
                    break;
                case 'email':
                    if (!/^\S+@\S+\.\S+$/.test(value)) newErrors.email = 'Invalid email';
                    else delete newErrors.email;
                    break;
                case 'contact':
                    if (!/^[6-9]\d{9}$/.test(value)) newErrors.contact = 'Invalid Indian number';
                    else delete newErrors.contact;
                    break;
                case 'address':
                    if (!value.trim()) newErrors.address = 'Address is required';
                    else delete newErrors.address;
                    break;
                case 'source':
                    if (!value) newErrors.source = 'Select your income source';
                    else delete newErrors.source;
                    break;
                case 'income':
                    if (!value) newErrors.income = 'Select income range';
                    else delete newErrors.income;
                    break;
                case 'query':
                    if (!value.trim()) newErrors.query = 'Please enter your concern';
                    else delete newErrors.query;
                    break;
                default:
                    break;
            }

            return newErrors;
        });
    };

    const validate = () => {
        const tempErrors = {};
        const emailRegex = /^\S+@\S+\.\S+$/;
        const phoneRegex = /^[6-9]\d{9}$/;

        if (!formData.name.trim()) tempErrors.name = 'Name is required';
        if (!emailRegex.test(formData.email)) tempErrors.email = 'Invalid email';
        if (!phoneRegex.test(formData.contact)) tempErrors.contact = 'Invalid Indian number';
        if (!formData.address.trim()) tempErrors.address = 'Address is required';
        if (!formData.source) tempErrors.source = 'Select your income source';
        if (!formData.income) tempErrors.income = 'Select income range';
        if (!formData.query.trim()) tempErrors.query = 'Please enter your concern';

        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            emailjs.send(
                "service_me1mtog",   // 🔹 Replace with your Service ID
                "template_efkyfai",  // 🔹 Replace with your Template ID
                {
                    name: formData.name,
                    email: formData.email,
                    contact: formData.contact,
                    address: formData.address,
                    source: formData.source,
                    income: formData.income,
                    query: formData.query,
                },
                "hLjHlJIegGmwywt4E"    // 🔹 Replace with your Public Key
            )
            .then(
                (result) => {
                    console.log(result.text);
                    Swal.fire({
                        icon: "success",
                        title: "Message Sent!",
                        text: "✅ Your message has been sent successfully.",
                        confirmButtonColor: "#3085d6",
                        });
                    setFormData({
                        name: "",
                        email: "",
                        contact: "",
                        address: "",
                        source: "",
                        income: "",
                        query: "",
                    }); // reset form
                },
                (error) => {
                    console.log(error.text);
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "❌ Failed to send message. Please try again.",
                        confirmButtonColor: "#d33",
                    });
                }
            );
        }
    };

    return (
        <div className="container pb-5" >
            <div className="card p-4 shadow-lg rounded-4 border-0">
                <h2 className="text-center fw-bold mb-4" style={{ color: '#3a0063' }}>
                    Get in Touch
                </h2>

                <form onSubmit={handleSubmit} noValidate>
                    <div className="row">
                        {/* Name */}
                        <div className="col-md-6 mb-3">
                            <label className="form-label">Name *</label>
                            <input
                                type="text"
                                className={`form-control rounded-3 shadow-sm ${errors.name ? 'is-invalid' : ''}`}
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                            />
                            <div className="invalid-feedback">{errors.name}</div>
                        </div>

                        {/* Email */}
                        <div className="col-md-6 mb-3">
                            <label className="form-label">Email *</label>
                            <input
                                type="email"
                                className={`form-control rounded-3 shadow-sm ${errors.email ? 'is-invalid' : ''}`}
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                            />
                            <div className="invalid-feedback">{errors.email}</div>
                        </div>
                    </div>

                    <div className="row">
                        {/* Contact */}
                        <div className="col-md-6 mb-3">
                            <label className="form-label">Contact *</label>
                            <input
                                type="text"
                                className={`form-control rounded-3 shadow-sm ${errors.contact ? 'is-invalid' : ''}`}
                                name="contact"
                                maxLength="10"
                                value={formData.contact}
                                onChange={handleChange}
                            />
                            <div className="invalid-feedback">{errors.contact}</div>
                        </div>

                        {/* Source */}
                        <div className="col-md-6 mb-3">
                            <label className="form-label">Income Source *</label>
                            <select
                                className={`form-select rounded-3 shadow-sm ${errors.source ? 'is-invalid' : ''}`}
                                name="source"
                                value={formData.source}
                                onChange={handleChange}
                            >
                                <option value="">-- Select --</option>
                                <option value="Business">Business</option>
                                <option value="Profession">Profession</option>
                                <option value="Salary">Salary</option>
                                <option value="Other">Other</option>
                            </select>
                            <div className="invalid-feedback">{errors.source}</div>
                        </div>
                    </div>

                    {/* Address */}
                    <div className="mb-3">
                        <label className="form-label">Address *</label>
                        <textarea
                            className={`form-control rounded-3 shadow-sm ${errors.address ? 'is-invalid' : ''}`}
                            name="address"
                            rows="2"
                            value={formData.address}
                            onChange={handleChange}
                        />
                        <div className="invalid-feedback">{errors.address}</div>
                    </div>

                    {/* Income */}
                    <div className="mb-3">
                        <label className="form-label">Annual Income *</label>
                        <select
                            className={`form-select rounded-3 shadow-sm ${errors.income ? 'is-invalid' : ''}`}
                            name="income"
                            value={formData.income}
                            onChange={handleChange}
                        >
                            <option value="">-- Select --</option>
                            <option value="1-3 Lacs">1-3 Lacs</option>
                            <option value="3-7 Lacs">3-7 Lacs</option>
                            <option value="7-12 Lacs">7-12 Lacs</option>
                            <option value="12+ Lacs">12+ Lacs</option>
                        </select>
                        <div className="invalid-feedback">{errors.income}</div>
                    </div>

                    {/* Query */}
                    <div className="mb-4">
                        <label className="form-label">Your Query *</label>
                        <input
                            type="text"
                            className={`form-control rounded-3 shadow-sm ${errors.query ? 'is-invalid' : ''}`}
                            name="query"
                            value={formData.query}
                            onChange={handleChange}
                        />
                        <div className="invalid-feedback">{errors.query}</div>
                    </div>

                    <div className="text-center">
                        <button
                            type="submit"
                            className="btn px-5 py-2 shadow"
                            style={{
                                backgroundColor: '#3a0063',
                                color: 'white',
                                border: 'none',
                                fontWeight: 'bold',
                            }}
                        >
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Contact;
